module.exports = require("@wel-ui/component-button");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/Button/index.js
// module id = 145
// module chunks = 0